import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHistory = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "-6 -6 36 36",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("polyline", {
			className: "plan2plate-icon",
			points: "20.63 0.5 20.63 6.25 14.88 6.25"
		}),
		/* @__PURE__ */ _jsx("polyline", {
			className: "plan2plate-icon",
			points: "3.38 23.5 3.38 17.75 9.13 17.75"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "plan2plate-icon",
			d: "M1.83,14.77A10.12,10.12,0,0,1,1.46,12,10.54,10.54,0,0,1,20.62,5.94"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "plan2plate-icon",
			d: "M22.17,9.23A10.12,10.12,0,0,1,22.54,12,10.54,10.54,0,0,1,3.38,18.06"
		})
	]
});
const ForwardRef = forwardRef(SvgHistory);
export default ForwardRef;
